// extracted by mini-css-extract-plugin
export default {"wrapperOverflow":"comentsModal_wrapperOverflow__t58ms"};